export enum SystemUserInfoType {
    PHONE = 'phone',
    ADDRESS = 'address',
    LINKEDIN = 'linkedin'
}
